/* @flow */
import { rem } from 'polished';
import { baseFontSize } from '@braindate/ui/lib/token/typography';
import { lap } from '@braindate/ui/lib/token/mediaQuery';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    minHeight: rem(37, baseFontSize),
    margin: [11, 0, 17, 0],
    display: 'flex',
    alignItems: 'center',

    [lap]: {
      maxWidth: '80%',
    },
  },
  topicTitle: {
    margin: 0,
    textAlign: 'left',
    textTransform: 'none',
    fontSize: rem(16, baseFontSize),
    color: ({ theme }: ThemeFunction) => theme.textColor,
  },
};
